/* eslint-disable import/no-mutable-exports */
/* eslint-disable import/newline-after-import */

let Module = require('../../../maps/ssr-dummy').default;

if (__CLIENT__) {
  Module = require('./editor-light').default;
}

export default Module;
